import { LOG_GROUP as EXTERNAL_LOG_GROUP } from '@sleepstation/logger'

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const LOG_GROUP = Object.freeze({
  ...EXTERNAL_LOG_GROUP,
  STARTUP: `Startup`,
  PAGE_MONITOR_SERVICE: `PageMonitorService`,
  AUTH: `auth`,
})

export default LOG_GROUP
